import React from "react";

/**
 * Iyare's hand-drawn signature, recoloured to azure blue with transparent bg.
 * Renders the signature image with the typed name beneath it.
 */
const Signature = ({ className = "h-12", align = "left" }) => (
  <div
    data-testid="iyare-signature"
    className={`inline-flex flex-col ${align === "right" ? "items-end" : "items-start"}`}
  >
    <img
      src="/signature-iyare.png"
      alt="Iyare Omoruyi signature"
      className={`w-auto ${className} select-none`}
      draggable="false"
    />
    <div className="mt-2 text-[10.5px] tracking-[0.34em] uppercase text-white/70">
      Iyare Omoruyi
    </div>
  </div>
);

export default Signature;
